import {
  FilePdfOutlined,
  FileWordOutlined,
  FileExcelOutlined,
  FileImageOutlined,
  FileTextOutlined,
} from "@ant-design/icons";

export function getFileExtension(fileName?: string | null): string {
  if (!fileName) {
    return "";
  }

  const parts = fileName.split(".");
  return parts.length > 1 ? (parts.pop() ?? "").toLowerCase() : "";
}

export function FileTypeIcon({
  fileName,
  className,
}: {
  fileName?: string | null;
  className?: string;
}) {
  const ext = getFileExtension(fileName);

  if (ext === "pdf") {
    return (
      <FilePdfOutlined className={className} style={{ color: "#E94F54" }} />
    );
  }

  if (["doc", "docx"].includes(ext)) {
    return (
      <FileWordOutlined className={className} style={{ color: "#2B579A" }} />
    );
  }

  if (["xls", "xlsx"].includes(ext)) {
    return (
      <FileExcelOutlined className={className} style={{ color: "#217346" }} />
    );
  }

  if (["png", "jpg", "jpeg", "gif", "webp", "svg"].includes(ext)) {
    return <FileImageOutlined className={className} />;
  }

  return <FileTextOutlined className={className} />;
}
